import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import { BodyParent, BodyChildren } from './animation/variants';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '375px',
      marginTop: '-40px',
      flexDirection: 'column-reverse !important',
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '950px',
      alignItems: 'center',
      marginTop: '-100px',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '1085px',
    },
  },
  laptopBooks: {
    [theme.breakpoints.down('sm')]: {
      width: '375px',
      height: '380px',
    },
    [theme.breakpoints.up('md')]: {
      width: '435px',
      height: '440px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '545px',
      height: '555px',
    },
  },
  title: {
    color: theme.palette.secondary.main,
  },
  description: {
    maxWidth: '950px',
    fontSize: 24,
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '31px',
    letterSpacing: '-0.04em',
    marginTop: '10px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
}));

const Wrapper = styled.div`
  display: flex;
`;

const LaptopWrapper = styled.div``;

const Body = styled.div`
  margin-left: 10px;
`;

const AboutUs = () => {
  const [ref, inView] = useInView({
    rootMargin: '-100px 100px',
    triggerOnce: true,
    width: '100%',
  });

  const classes = useStyles();

  return (
    <motion.div
      ref={ref}
      variants={BodyParent}
      initial="initial"
      animate={inView ? 'enter' : 'initial'}>
      <Wrapper className={classes.root}>
        <LaptopWrapper>
          <motion.img
            variants={BodyChildren}
            src={require('./assets/laptop-books.png')}
            alt="laptop-books"
            className={classes.laptopBooks}
          />
        </LaptopWrapper>
        <Body>
          <motion.div variants={BodyChildren}>
            <Typography variant="h2" className={classes.title}>
              About Us
            </Typography>
          </motion.div>
          <motion.p className={classes.description} variants={BodyChildren}>
            Hack Western is one of Canada's largest annual student-run
            hackathons. Our mission is to inspire the next generation of
            problem-solvers.
            <br />
            <br />
            Join 600+ students from across the globe in our first digital
            hackathon to build, learn and innovate. Collaborate in teams to
            build web, mobile, and hardware projects, while participating in
            workshops, learning from mentors, and competing for prizes.
          </motion.p>
        </Body>
      </Wrapper>
    </motion.div>
  );
};

export default AboutUs;
